import {
  SET_CITIES,
  SET_COUNTRIES,
  SET_CREW_ROLES,
  SET_FINISH_COUNTRIES,
  SET_FINISH_MARINAS,
  SET_LICENSE_SYSTEMS,
  SET_LICENSE_TYPES,
  SET_MARINAS,
  SET_OPERATORS,
  SET_REGIONS,
  SET_SHIPYARDS,
  SET_YACHT_MODELS,
  SET_YACHT_TYPES,
  SET_YACHTS
} from "./data-types";


export const setMarinas = (marinas) => ({type: SET_MARINAS, marinas})
export const setFinishMarinas = (finishMarinas) => ({type: SET_FINISH_MARINAS, finishMarinas})
export const setYachtModels = (yachtModels) => ({type: SET_YACHT_MODELS, yachtModels})
export const setShipyards = (shipyards) => ({type: SET_SHIPYARDS, shipyards})
export const setYachtTypes = (yachtTypes) => ({type: SET_YACHT_TYPES, yachtTypes})
export const setYachts = (yachts) => ({type: SET_YACHTS, yachts})
export const setRegions = (regions) => ({type: SET_REGIONS, regions})
export const setCountries = (countries) => ({type: SET_COUNTRIES, countries})
export const setFinishCountries = (finishCountries) => ({type: SET_FINISH_COUNTRIES, finishCountries})
export const setCities = (cities) => ({type: SET_CITIES, cities})
export const setCrewRoles = (crewRoles) => ({type: SET_CREW_ROLES, crewRoles})
export const setOperators = (operators) => ({type: SET_OPERATORS, operators})
export const setLicenseSystems = (licenseSystems) => ({type: SET_LICENSE_SYSTEMS, licenseSystems})
export const setLicenseTypes = (licenseTypes) => ({type: SET_LICENSE_TYPES, licenseTypes})
